import { APIService } from '../service'
import { IJsonApiModelWithId, IFetchMultipleQueryOptions } from '../types'
import { deserializeTransformer } from '../serializer'

declare module '../service' {
  interface APIService {
    fetchAllGlobalDeliveryDays(requestOpts?: IFetchMultipleQueryOptions): Promise<IGlobalDeliveryDay[]>
  }
}

export const ENTITY_TYPE_GLOBAL_DELIVERY_DAY = 'global-delivery-days'

export interface IGlobalDeliveryDay extends IJsonApiModelWithId {
  id: string
  date: Date
}

APIService.prototype.fetchAllGlobalDeliveryDays = async function (
  requestOpts?: IFetchMultipleQueryOptions,
) {
  return this.fetchAll<IGlobalDeliveryDay>(ENTITY_TYPE_GLOBAL_DELIVERY_DAY, requestOpts)
}

deserializeTransformer.register(ENTITY_TYPE_GLOBAL_DELIVERY_DAY, {
  date: (v: string) => new Date(v),
})
